export default {
      id: "oc-res-instance-backup-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-instance-backup",
      toString: function () {
        return this.url;
      }
    }